import { cn } from "@/lib/utils";

export interface EntryValueLabelProps {
	children: React.ReactNode;
	size?: "sm" | "md" | "lg";
}

export const EntryValueLabel = ({
	children,
	size = "md",
}: EntryValueLabelProps) => {
	return (
		<span
			className={cn(
				"min-w-16 font-medium text-slate-500",
				size === "sm" && "text-xs",
				size === "md" && "text-sm",
				size === "lg" && "text-base",
			)}
		>
			{children}
		</span>
	);
};
